/**
 * Copyright © 2024 Delicious AI, LLC
 */

import { isEmpty, difference } from 'lodash'

const isSameSet = (a: any[], b: any[]) =>
  isEmpty(difference(a, b)) && isEmpty(difference(b, a))

export const SetHelpers = {
  isSameSet,
}
